module.exports = __webpack_public_path__ + "static/media/img_slideshow1.96163310.jpg";